@if (item) {
  @switch (item | stitchType) {
    @case (StitchType.EVENT) {
      <app-event-form
        id="event-form"
        [event]="asCalendarEvent(item)"
        (close)="handleFormClose($event)"
        />
    }
    @case (StitchType.CALENDAR) {
      <app-calendar-form
        id="calendar-form"
        [calendar]="asCalendar(item)"
        (close)="handleFormClose($event)"
        />
    }
    @case (StitchType.MESSAGE) {
      <ng-container *appMailAppContext>
        <app-message2-form
          id="message2-form"
          [message]="asMessage(item)"
          [autoSaveAllowed]="false"
          (close)="handleFormClose($event)"
          />
      </ng-container>
    }
  }
} @else if (virtualFolder() === 'all_events') {
  <stch-full-calendar />
} @else if (section() === 'calendars') {
  <app-no-content-stub imageSrc="assets/placeholders/placeholder-schedule.svg" [size]="124">
    <p class="text-base font-medium text-gray-900 text-center">No calendar selected</p>
    <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewCalendar()">
      <app-icon name="calendar-grid" />
      Create a new calendar
    </app-button2>
  </app-no-content-stub>
} @else if (virtualFolder() === 'received_invites') {
  <!-- New events never land in Received Invites, so no create button here (Johanna, 2026-10-21). -->
  <app-no-content-stub imageSrc="assets/placeholders/placeholder-schedule.svg" [size]="124">
    <p class="text-base font-medium text-gray-900 text-center">No invite selected</p>
  </app-no-content-stub>
} @else if (virtualFolder() === 'sent_invites') {
  <!-- A new event with guests shows up here; the button opens New Event like the rail's (Johanna, 2026-10-21). -->
  <app-no-content-stub imageSrc="assets/placeholders/placeholder-schedule.svg" [size]="124">
    <p class="text-base font-medium text-gray-900 text-center">No event invite selected</p>
    <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewEvent()">
      <app-icon name="calendar-today" />
      Create a new event
    </app-button2>
  </app-no-content-stub>
} @else {
  <app-no-content-stub imageSrc="assets/placeholders/placeholder-schedule.svg" [size]="124">
    <p class="text-base font-medium text-gray-900 text-center">No event selected</p>
    <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewEvent()">
      <app-icon name="calendar-today" />
      Create a new event
    </app-button2>
  </app-no-content-stub>
}
